module.exports = __webpack_public_path__ + "img/add.1e75ea61.svg";